<script lang="ts">
  interface Props {
    time?: string;
    isTestEnv?: boolean;
  }

  let { time = '', isTestEnv = false }: Props = $props();
</script>

<div class="test-env-banner" class:testEnv={isTestEnv}>
  {#if isTestEnv}
    <div class="content test-env">Test environment -</div>
  {/if}
  <div class="content">
    TEMPORARY LOGIN. YOUR SESSION EXPIRES IN
    <div class="time">{time || '...'}</div>
  </div>
</div>

<style>
  .test-env-banner {
    display: flex;
    align-items: center;
    justify-content: center;
    line-height: 16px;
    font-weight: bold;
    font-size: 10px;
    text-transform: uppercase;
    width: 100%;
    height: 20px;
    background-color: var(--light-blue);
    color: var(--blue);
  }
  .testEnv {
    background-color: #fdf35c;
    color: rgba(80, 75, 2, 0.5);
  }
  .content {
    display: flex;
  }
  .content:not(:last-child) {
    margin-right: 4px;
  }
  .time {
    margin-left: 4px;
    text-transform: none;
  }
</style>
